import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { NormalizedFormValues, Report } from '../../shared/types';

import type {
	PetitionReportAbuseSunriseMutation,
	PetitionReportAbuseSunriseMutationVariables,
} from './petitionReportAbuse.graphql';
import { PetitionReportAbuseSunrise } from './petitionReportAbuse.graphql';

export async function reportAbuse(
	input: NormalizedFormValues & Report,
	{ gql: { fetch } }: UtilityContext,
): Promise<boolean> {
	const { data } = await fetch<PetitionReportAbuseSunriseMutation, PetitionReportAbuseSunriseMutationVariables>({
		query: PetitionReportAbuseSunrise,
		variables: { input },
		rejectOnError: true,
	});

	if (data.petitionReportAbuse.__typename === 'ReportAbuseFailure') {
		throw new Error(data.petitionReportAbuse.error);
	}

	return data.petitionReportAbuse.success;
}
